<template>
    <div class="illustration pb-2 pt-3">
    <img :src="data.img?data.img:'/img/empty-2.svg'" :class="data.size?data.size:''">
        <h5 class="title mb-2">
            {{data.title || 'Tidak ada apapun di sini'}}
        </h5>
        <p class="content mb-2">
           {{ data.content || 'Tambahkan item baru agar dapat ditampilkan di sini'}}
        </p>
        <div v-if="data.link" class="action">
            <router-link :to="data.link" class="btn btn-outline-primary mx-2 text-uppercase">{{data.label}}</router-link>
        </div>
    </div>
</template>
<style>
img.small{
    width:7rem !important;
    height:5rem !important;
    margin-bottom:.75rem !important;
}
</style>
<script>

export default {
  name: "EmptyState",
  components: {},
  props: {
      data:Object
  },
  data: function() {
    return {};
  },
  methods: {

  }
};
</script>